module.exports = __webpack_public_path__ + "static/img/product_images_big13_h5_zh.2f9e0ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_big13_h5_zh.png
// module id = 5IMY
// module chunks = 34